import { get, post } from './axios'

export default {
  // 添加签名
  addUserSign(params) {
    return post('/user/my/addUserSign', params)
  },
}
